var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',[_c('icon',{attrs:{"name":"NULL"}})],1),_c('div',{staticClass:"text"},[_vm._v("什么都没有呢")])])}
var staticRenderFns = []

export { render, staticRenderFns }